import React from 'react';
import immutable from 'immutable';
import Chip from 'components/pure/utils/Chip';

require('styles/utils/InlineItemList.styl');

/**
 * Render a generic list of items on the page
 *
 * @param itemList - list of items to render - should contain id, label|name
 * @param onRemove - what to do when remove is clicked
 * @param colorScheme - optional color scheme to render the items in pretty colors
 */
export default ({itemList, onRemove, colorScheme}) => {
  if (itemList) {
    if (immutable.Iterable.isIterable(itemList) && itemList.count() === 0) {
      return null;
    } else if (itemList.length === 0) {
      return null;
    }
  }

  const itemKey = item => {
    return item && item.id ? item.id : item;
  };

  const itemLabel = item => {
    let label = item;
    if (item && item.label) {
      label = item.label;
    } else if (item && item.name) {
      label = item.name;
    }
    return label;
  };

  return (
    <div className="inline-item-list">
      {itemList
        ? itemList.map((item, i) => {
            const key = itemKey(item);
            const label = itemLabel(item);
            const color = colorScheme && colorScheme.get(i % colorScheme.size);
            return (
              <Chip key={key} onRemove={() => onRemove(item)} color={color} text="#fff">
                {label}
              </Chip>
            );
          })
        : null}
    </div>
  );
};
